import { createTheme } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";


export const theme = createTheme(
    deepmerge(
        createTheme(),
        {
            palette: {
                primary: {
                main: "#1155AA"
                },
                error: {
                main: "#EF1B1B"
                },
                info: {
                main: "#3B71FE"
                }
            },
            components: {
                MuiCssBaseline: {
                styleOverrides: `
                    h1 {
                    color: grey;
                    };
                `,
                },
                MuiButton: {
                styleOverrides: {
                    root: {
                    fontSize: 16,
                    textTransform: "inherit",
                    fontWeight: 600,
                    boxShadow: "unset",
                    // fontFamily: "Inter",
                    borderRadius: "10px",
                    "&:hover": {
                        boxShadow: "none",
                    }
                    },
                    text: {
                    "&:hover": {
                        backgroundColor: "transparent"
                    }
                    }
                }
                },
                MuiTypography: {
                styleOverrides: {
                    root: {
                    // fontFamily: "Inter"
                    },
                    body2: {
                    fontSize: 16
                    },
                    subtitle1: {
                    fontSize: 14
                    }
                }
                },
                MuiTab: {
                styleOverrides: {
                    root: {
                    "&.Mui-selected": {
                        color: "#000000",
                    },
                    textTransform: "capitalize",
                    padding: "12px 20px"
                    }
                }
                }
            },
        }
    )
);
